import './style.scss';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import GenericActions from '../../actions/GenericActions';
import { Modal } from '../../components';
import { Button } from 'lib/@mui';
import classNames from 'classnames';
import { useTranslate } from '../../features/languages';
import { EZLOGIC_TITLE_GOT_IT } from '../../constants/language_tokens';
import { ErrorIcon } from '../../assets/icons';
import style from './style.module.scss';

const ErrorDialog = () => {
    const { show, message, errorTitle } = useSelector((state) => state.app.error);
    const dispatch = useDispatch();
    const { t } = useTranslate();

    const close = () => {
        dispatch(GenericActions.hideError());
    };

    return (
        <Modal
            footer={null}
            closable={false}
            centered
            visible={show}
            onCancel={close}
            className={style.errorModal}
            maskClosable={false}
            maskStyle={{
                background: 'rgba(28, 30, 33, 0.75)',
            }}
        >
            <div className={style.wrapper}>
                <ErrorIcon height={104} width={104} className="icon" />
                <h2 className="title">{t(errorTitle)}</h2>
                <p className="message">{t(message)}</p>
                <Button autoFocus className={classNames('btn', 'warning')} onClick={close}>
                    {t(EZLOGIC_TITLE_GOT_IT)}
                </Button>
            </div>
        </Modal>
    );
};

export default ErrorDialog;
